import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export const HeroSection = () => {
  return <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden bg-navy-900" data-id="element-101">
      {/* Background Photo */}
      <div className="absolute inset-0" data-id="element-102">
        <img src="https://cdn.magicpatterns.com/uploads/drnjLYkADkGvq7ohwJ1YTF/5754.png" alt="" className="w-full h-full object-cover object-center opacity-40" data-id="element-103" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-navy-900/40 via-navy-900/70 to-navy-900" data-id="element-104"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-navy-900/70 via-transparent to-navy-900/70" data-id="element-105"></div>

      {/* Abstract Hockey Graphic / Lines */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        pathLength: 0
      }} animate={{
        opacity: 0.1,
        pathLength: 1
      }} transition={{
        duration: 2,
        ease: 'easeInOut'
      }} className="absolute top-1/4 -left-64 w-[200%] h-[1px] bg-ice-500 transform -rotate-12" data-id="element-107" />
        <motion.div initial={{
        opacity: 0,
        pathLength: 0
      }} animate={{
        opacity: 0.05,
        pathLength: 1
      }} transition={{
        duration: 2.5,
        ease: 'easeInOut',
        delay: 0.2
      }} className="absolute top-1/3 -left-64 w-[200%] h-[1px] bg-white transform -rotate-12" data-id="element-108" />

        {/* Faceoff circle abstract */}
        <motion.div initial={{
        scale: 0.8,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 0.03
      }} transition={{
        duration: 3,
        ease: 'easeOut'
      }} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] border-[40px] border-ice-500 rounded-full" data-id="element-109" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center flex flex-col items-center" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-111">
          <span className="inline-block py-1 px-3 rounded-full bg-navy-800 border border-navy-700 text-ice-500 text-sm font-semibold tracking-wider mb-6" data-id="element-112">
            U10 TO PROFESSIONAL
          </span>
        </motion.div>

        <motion.h1 className="text-5xl md:text-7xl lg:text-8xl font-black text-white tracking-tight mb-6 text-balance uppercase" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut',
        delay: 0.1
      }} data-id="element-113">
          Development First.
          <br data-id="element-114" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-slate-400" data-id="element-115">
            Results Always.
          </span>
        </motion.h1>

        <motion.p className="text-lg md:text-xl text-slate-300 max-w-3xl mx-auto mb-10 text-balance leading-relaxed" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut',
        delay: 0.2
      }} data-id="element-116">
          Former professional hockey players guiding the next generation. We
          provide honest representation, elite mentorship, and strategic pathway
          mapping to help players thrive in every environment.
        </motion.p>

        <motion.div className="flex flex-col sm:flex-row gap-4 justify-center w-full sm:w-auto" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut',
        delay: 0.3
      }} data-id="element-117">
          <a href="#contact" className="px-8 py-4 bg-gold-500 hover:bg-gold-400 text-navy-900 font-bold text-lg rounded-sm transition-all transform hover:-translate-y-1 shadow-lg shadow-gold-500/20 flex items-center justify-center" data-id="element-118">
            Get Started
          </a>
          <a href="#mission" className="px-8 py-4 bg-transparent border-2 border-slate-600 hover:border-white text-white font-bold text-lg rounded-sm transition-all flex items-center justify-center" data-id="element-119">
            Learn More
          </a>
        </motion.div>
      </div>

      <motion.div className="absolute bottom-10 left-1/2 -translate-x-1/2 text-slate-400 flex flex-col items-center gap-2" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} data-id="element-120">
        <span className="text-xs font-semibold tracking-widest uppercase" data-id="element-121">
          Scroll
        </span>
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }} data-id="element-122">
          <ChevronDown size={20} data-id="element-123" />
        </motion.div>
      </motion.div>
    </section>;
};